import React from "react";
import { ButtonProps } from "components/v2/Button/types/ButtonProps";
import classes from "./Button.module.scss";
import classnames from "classnames";

const Button: React.FC<ButtonProps> = (ButtonProps) => {
  let buttonTypeClassname;
  switch (ButtonProps.type) {
    case "primary":
      buttonTypeClassname = classes.primary;
      break;
    case "secondary":
      buttonTypeClassname = classes.secondary;
      break;
    case "basic":
      buttonTypeClassname = classes.basic;
      break;
    case "others":
      switch (ButtonProps.color) {
        case "purple":
          buttonTypeClassname = classes.purple;
          break;
        case "orange":
          buttonTypeClassname = classes.orange;
          break;
        case "blue":
          buttonTypeClassname = classes.blue;
          break;
        case "gray":
          buttonTypeClassname = classes.gray;
      }
      break;
  }
  return (
    <button
      disabled={ButtonProps.disabled}
      onClick={
        ButtonProps?.eventOnClick
          ? ButtonProps?.eventOnClick
          : ButtonProps.onClick
      }
      className={classnames(
        buttonTypeClassname,
        classes.button,
        ButtonProps.additionalStyles,
        ButtonProps.leftIcon ? classes["left-icon"] : "",
      )}
    >
      {ButtonProps.icon}
      <div> {ButtonProps.text}</div>
    </button>
  );
};
export default Button;
